// 图片加载器 - 支持关卡图片、UI图片、预加载

export class ImageLoader {
  private cache: Map<string, HTMLImageElement> = new Map();
  private loading: Map<string, Promise<HTMLImageElement>> = new Map();

  load(src: string): Promise<HTMLImageElement> {
    if (this.cache.has(src)) {
      return Promise.resolve(this.cache.get(src)!);
    }
    if (this.loading.has(src)) {
      return this.loading.get(src)!;
    }
    const promise = new Promise<HTMLImageElement>((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        this.cache.set(src, img);
        this.loading.delete(src);
        resolve(img);
      };
      img.onerror = () => {
        this.loading.delete(src);
        reject(new Error(`Failed to load: ${src}`));
      };
      img.src = src;
    });
    this.loading.set(src, promise);
    return promise;
  }

  get(src: string): HTMLImageElement | undefined {
    return this.cache.get(src);
  }

  preload(sources: string[]): Promise<void> {
    return Promise.all(sources.map(s => this.load(s).catch(() => null))).then(() => undefined);
  }
}

// 加载关卡配置
export async function loadLevelConfig(levelId: string): Promise<any> {
  const response = await fetch(`level_list/${levelId}.json`);
  if (!response.ok) throw new Error(`Failed to load level config: ${levelId}`);
  return response.json();
}

// 加载关卡图片
export async function loadLevelImage(imageAssetPath: string, loader: ImageLoader): Promise<HTMLImageElement> {
  // imageAssetPath 类似 "/images/puzzle/G0001.png"
  // 实际图片在 level_pic/G0001.png
  const fileName = imageAssetPath.split('/').pop()!;
  return loader.load(`level_pic/${fileName}`);
}
